export default {
  tagline: 'Vaše prémiové místo pro digitální herní klíče. Bezpečně, okamžitě a spolehlivě.',
  nav: {
    shop: 'Obchod',
    catalog: 'Katalog',
    support: 'Podpora',
    supportLink: 'Podpora',
    faq: 'Časté dotazy',
    privacyPolicy: 'Zásady ochrany osobních údajů',
    termsOfService: 'Obchodní podmínky',
    cookiePolicy: 'Zásady používání souborů cookie',
  },
  payments: 'Přijímáme',
  nav2: {
    account: 'Účet',
    dashboard: 'Přehled',
    orders: 'Objednávky',
    wishlist: 'Oblíbené',
    platforms: 'Platformy',
  },
  copyright: '© {year} KeyzoStore. Všechna práva vyhrazena.',
  facts: {
    instant: 'Okamžité doručení',
    receipt: 'PDF faktura ke každému dobití',
    // Plural: 1 klíč | 2–4 klíče | 5+ klíčů
    stock: '{count} klíč skladem | {count} klíče skladem | {count} klíčů skladem',
  },
};
